import React from "react";

import { TextTypes, TextColors } from "../../../constants";
import { Link } from "../../../Link";
import { Text } from "../../../Text";
import { NotificationSection } from "../../../NotificationSection";

import "./styles.scss";

// Relates to: Profile Insurance Status

export const Declined = ({ copay, carrier, dateChecked }) => {
    return (
        <NotificationSection className={"declined"}>
            <Text className={"bold mb-3"}>
                Unfortunately, your new insurance does not cover aptihealth's services.
            </Text>

            <Text>
                <>
                    <div className="mb-3">
                        Contact{" "}
                        <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link> or{" "}
                        <Link href="tel:8884543827">(888) 454-3827</Link> before your next
                        appointment to prevent billing issues.
                    </div>
                    <div>Checked: {dateChecked}</div>
                </>
            </Text>
        </NotificationSection>
    );
};

Declined.defaultProps = {
    copay: null,
    dateChecked: "",
    carrier: "",
};
